// rem单位计算
var _viewport=document.body.clientWidth;
	_viewport=_viewport>1920?1920:_viewport;
var fontSize=_viewport/19.20;
window.screenWidth_ = _viewport;
console.log(_viewport);
window.document.getElementsByTagName("html")[0].style.fontSize = fontSize+'px';

window.onresize = () => {
  //history.go(0);
};